import { FormlyFieldConfig } from '@ngx-formly/core';
import { DetailsFormOptions } from './details-form-options.interface';
import { toFormlyOptions } from './details-form-helpers';

/**
 * SECTION 2.5: CLIENT EMPLOYMENT INFORMATION
 */
export function getClientEmploymentFields(options: DetailsFormOptions): FormlyFieldConfig[] {
	return [
		// Employment Section
		{
			fieldGroupClassName: 'row',
			fieldGroup: [
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Employer',
					type: 'input',
					props: {
						label: 'Employer',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Industry',
					type: 'searchable-select',
					props: {
						label: 'Industry',
						options: options.industries$,
						valueProp: 'display_value',
						labelProp: 'display_value',
						searchPlaceholder: 'Search industries',
						noEntriesFoundLabel: 'No matching industries found',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Employment_Status1',
					type: 'select',
					props: {
						label: 'Employment Status',
						options: toFormlyOptions(options.employmentStatuses$),
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Occupation',
					type: 'searchable-select',
					props: {
						label: 'Occupation',
						options: options.occupations$,
						valueProp: 'display_value',
						labelProp: 'display_value',
						searchPlaceholder: 'Search occupations',
						noEntriesFoundLabel: 'No matching occupations found',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Work_Phone',
					type: 'phone',
					props: {
						label: 'Work Phone',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Pay_Frequency2',
					type: 'select',
					props: {
						label: 'Pay Frequency',
						options: toFormlyOptions(options.payFrequencies$),
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Work_Extension',
					type: 'input',
					props: {
						label: 'Work Extension',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Income_net_paycheque_income',
					type: 'currency',
					props: {
						label: 'Income (net paycheque income)',
					},
				},
			],
		},
		{
			fieldGroupClassName: 'row',
			fieldGroup: [
				{
					className: 'col-sm-6 col-lg-4',
					key: '_employmentYears',
					type: 'input',
					props: {
						label: 'Employment Years',
						type: 'number',
						min: 0,
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: '_employmentMonths',
					type: 'input',
					props: {
						label: 'Employment Months',
						type: 'number',
						min: 0,
						max: 11,
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Last_Pay_Date',
					type: 'datepicker',
					props: {
						label: 'Last Pay Date',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Position',
					type: 'input',
					props: {
						label: 'Position',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Supervisor_Name',
					type: 'input',
					props: {
						label: 'Supervisor Name',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Previous_Employment',
					type: 'select',
					props: {
						label: 'Previous Employment Section?',
						options: [
							{ value: 'Yes', label: 'Yes' },
							{ value: 'No', label: 'No' },
						],
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Next_Pay_Date',
					type: 'datepicker',
					props: {
						label: 'Next Pay Date',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Supervisor_Phone_Number',
					type: 'phone',
					props: {
						label: 'Supervisor Phone Number',
					},
				},
				{
					className: 'col-sm-12',
					key: 'Additional_Employment',
					type: 'textarea',
					props: {
						label: 'Additional Employment',
						rows: 4,
					},
				},
			],
		},

		// Previous Employment (conditional)
		{
			fieldGroupClassName: 'row',
			expressions: {
				hide: (field: FormlyFieldConfig) =>
					field.model?.Previous_Employment !== 'Yes',
			},
			fieldGroup: [
				{
					type: 'section-header',
					props: {
						label: 'Previous Employment',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Previous_Employment_Type',
					type: 'select',
					props: {
						label: 'Previous Employment Type',
						options: toFormlyOptions(options.employmentStatuses$),
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Previous_Position',
					type: 'input',
					props: {
						label: 'Previous Position',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Previous_Employer',
					type: 'input',
					props: {
						label: 'Previous Employer',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Previous_Length_of_Employment',
					type: 'input',
					props: {
						label: 'Previous Length of Employment (Month)',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Previous_Supervisor_Name',
					type: 'input',
					props: {
						label: 'Previous Supervisor Name',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Previous_Supervisor_Phone_number',
					type: 'phone',
					props: {
						label: 'Previous Supervisor Phone number',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Previous_Income_net_paycheque_income',
					type: 'currency',
					props: {
						label: 'Previous Income(net paycheque income)',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Previous_Pay_Frequency',
					type: 'select',
					props: {
						label: 'Previous Pay Frequency',
						options: toFormlyOptions(options.payFrequencies$),
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Previous_Payment_Method',
					type: 'select',
					props: {
						label: 'Previous Payment Method',
						options: toFormlyOptions(options.paymentMethods$),
					},
				},
			],
		},
	];
}